import { Navigate, useLocation } from "react-router-dom";
import { useV2Session } from "../context/V2SessionContext";
import V2Layout from "./V2Layout";

export function V2Protected({ children }) {
  const { hasV2Session, hasRequiredWeight, loading, needsPasswordSetup } = useV2Session();
  const location = useLocation();

  if (loading) return <V2Loading />;
  if (needsPasswordSetup && location.pathname !== "/complete-registration") {
    return <Navigate to="/complete-registration" replace />;
  }
  if (!hasV2Session) return <Navigate to="/login" replace />;
  if (!hasRequiredWeight && location.pathname !== "/settings") {
    return <Navigate to="/settings" replace state={{ requireWeight: true }} />;
  }

  return <V2Layout>{children}</V2Layout>;
}

export function V2AdminProtected({ children }) {
  const { hasAdminAccess, hasV2Session, hasRequiredWeight, loading, needsPasswordSetup } = useV2Session();

  if (loading) return <V2Loading />;
  if (needsPasswordSetup) return <Navigate to="/complete-registration" replace />;
  if (!hasV2Session) return <Navigate to="/login" replace />;
  if (!hasAdminAccess) return <Navigate to="/dashboard" replace />;
  if (!hasRequiredWeight) return <Navigate to="/settings" replace state={{ requireWeight: true }} />;

  return <V2Layout>{children}</V2Layout>;
}

export function V2PublicOnly({ children }) {
  const { hasV2Session, hasRequiredWeight, isGuest, loading, needsPasswordSetup } = useV2Session();

  if (loading) return <V2Loading />;
  if (needsPasswordSetup) return <Navigate to="/complete-registration" replace />;
  if (hasV2Session && !isGuest) {
    return <Navigate to={hasRequiredWeight ? "/dashboard" : "/settings"} replace />;
  }

  return children;
}

function V2Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="animate-pulse text-muted-foreground">Loading...</div>
    </div>
  );
}
